import React, { FunctionComponent, ReactElement, useState } from "react";

import { bemClassNames, createQA, EMPTY_ARRAY } from "@multiweb/reactUtils";
import { TabProps } from "./Tab";

const classNames = bemClassNames("tabs-component");
const tabsContainer = classNames("tabsDivContainer");
const tabsList = classNames("tabsList");

const tabsComponentDataQA = createQA("tabs-component");
const tabsContainerDataQA = createQA("tabs-container");
const tabsContentDataQA = createQA("tabs-content");

export type TabsProps = {
    children: ReactElement<TabProps>[];
    /** určuje výchozí záložku */
    defaultTabIndex?: number;
    /** callback funkce */
    onTabChange?: (activeTabIndex: number) => void;
};

export const Tabs: FunctionComponent<TabsProps> = ({
    children = EMPTY_ARRAY as ReactElement<TabProps>[],
    defaultTabIndex = 0,
    onTabChange,
}) => {
    const [activeTabIndex, setActiveTabIndex] = useState(defaultTabIndex);

    /** funkce ošetřující případ, kdy se změní počet children při odebírání záložek */
    const getActiveTabIndex = () => {
        if (children.length - 1 >= activeTabIndex)
            return activeTabIndex;

        return children.length - 1;
    };

    const handleClick = (tabIndex: number) => {
        setActiveTabIndex(tabIndex);

        if (onTabChange)
            onTabChange(tabIndex);
    };

    return (
        <div {...tabsComponentDataQA} className={classNames()}>
            <div {...tabsContainerDataQA} className={tabsContainer}>
                <ul className={tabsList}>
                    {React.Children.map(children, (child: ReactElement<TabProps>, i) => {
                        return (<li
                            {...createQA(`tab-${child.props.tabName}`)}
                            key={child.props.tabName}
                            className={classNames("tab", { "active": activeTabIndex === i })}
                            onClick={() => handleClick(i)}
                        >
                            {child.props.tabName}
                        </li>);
                    })}
                </ul>
            </div>
            <div {...tabsContentDataQA} className={classNames("content")}>
                {children[getActiveTabIndex()]}
            </div>
        </div>
    );
};
